/**
 * Applies domain-driven branding
 */

define([
    'edge/platform/branding/SetBranding'
], ()=> {
    return angular.module('edge.platform.branding', []);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/branding/module.js